module.exports = __webpack_public_path__ + "img/plumbing-icon-17-with-circle.6452c42b.png";